import React from "react";
import ContableModule from "../Contable";

export default function Resumen() {
  return <ContableModule view="summary" />;
}
